import React from "react";

const ModelViewReklamaBleresit = ({ tableContent }) => {
  const tvStations = ["RTSH 1", "Top Channel", "Klan", "Vizion Plus"];

  const monthOrder = [
    "Janar",
    "Shkurt",
    "Mars",
    "Prill",
    "Maj",
    "Qershor",
    "Korrik",
    "Gusht",
    "Shtator",
    "Tetor",
    "Nëntor",
    "Dhjetor",
  ];

  const getTop5ByTV = (data, tv) => {
    const filtered = data
      .filter((item) => item.TV.trim() === tv)
      .reduce((acc, curr) => {
        const key = curr.Subjekti;
        const min = parseFloat(curr["Koha / min"]);
        acc[key] = (acc[key] || 0) + min;
        return acc;
      }, {});

    return Object.entries(filtered)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 5);
  };

  const renderTVTable = (tvLeft, tvRight, data) => {
    const left = getTop5ByTV(data, tvLeft);
    const right = getTop5ByTV(data, tvRight);
    const maxRows = Math.max(left.length, right.length);

    return (
      <div style={{ marginBottom: "20px" }}>
        {/* TV Names Header */}
        <div style={styles.tvHeaderRow}>
          <div style={{ ...styles.tvHeaderCell, width: "50%" }}>{tvLeft}</div>
          <div style={{ ...styles.tvHeaderCell, width: "50%" }}>{tvRight}</div>
        </div>

        <table style={styles.table}>
          <thead>
            <tr style={styles.headerRow}>
              <th style={{ ...styles.th, ...styles.nrColumn }}>Nr</th>
              <th style={{ ...styles.th, ...styles.subjectColumn }}>
                Subjekti
              </th>
              <th style={{ ...styles.th, ...styles.timeColumn }}>Koha/min</th>
              <th style={{ ...styles.th, ...styles.subjectColumn }}>
                Subjekti
              </th>
              <th style={{ ...styles.th, ...styles.timeColumn }}>Koha/min</th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: maxRows }).map((_, i) => (
              <tr key={i}>
                <td style={{ ...styles.td, ...styles.nrColumn }}>{i + 1}</td>
                <td style={{ ...styles.td, ...styles.subjectColumn }}>
                  {left[i]?.[0] || ""}
                </td>
                <td style={{ ...styles.td, ...styles.timeColumn }}>
                  {left[i]?.[1]?.toFixed(2) || ""}
                </td>
                <td style={{ ...styles.td, ...styles.subjectColumn }}>
                  {right[i]?.[0] || ""}
                </td>
                <td style={{ ...styles.td, ...styles.timeColumn }}>
                  {right[i]?.[1]?.toFixed(2) || ""}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  const sortedEntries = Object.entries(tableContent).sort(
    ([monthA], [monthB]) =>
      monthOrder.indexOf(monthA) - monthOrder.indexOf(monthB)
  );

  return (
    <div style={{ padding: "20px" }}>
      {sortedEntries.map(([muaji, data]) => (
        <div key={muaji} style={{ marginBottom: "60px" }}>
          <h2 style={styles.monthTitle}>{muaji}</h2>
          {renderTVTable("RTSH 1", "Top Channel", data)}
          <div style={{ height: "20px" }}></div>
          {renderTVTable("Klan", "Vizion Plus", data)}
        </div>
      ))}
    </div>
  );
};

const styles = {
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: "20px",
    tableLayout: "fixed",
  },
  monthTitle: {
    fontSize: "22px",
    color: "#ed1d25",
    marginBottom: "10px",
  },
  tvHeaderRow: {
    display: "flex",
    backgroundColor: "#ed1d25",
    color: "white",
    fontWeight: "bold",
    textAlign: "center",
    fontSize: "16px",
    padding: "6px 0",
  },
  tvHeaderCell: {
    textAlign: "center",
    padding: "4px 8px",
  },
  headerRow: {
    color: "black",
  },
  th: {
    borderBottom: "1px solid #ddd",
    padding: "8px",
    fontWeight: "bold",
    textAlign: "left",
  },
  td: {
    borderBottom: "1px solid #ddd",
    padding: "8px",
    textAlign: "left",
  },
  nrColumn: {
    width: "40px",
    whiteSpace: "nowrap",
    textAlign: "center",
  },
  timeColumn: {
    width: "70px",
    whiteSpace: "nowrap",
    textAlign: "center",
  },
  subjectColumn: {
    width: "200px",
    wordBreak: "break-word",
  },
};

export default ModelViewReklamaBleresit;
